import React from "react";
import {AiFillInfoCircle} from 'react-icons/ai';

let WarningLabel = ({text}) => <label className='warning-text'>
    <AiFillInfoCircle/>
    {text}
</label>

export default WarningLabel